import { UseEndpointOptionsFromProvider, useEndpoint } from '../../core'
import { getAccessManagementAccount } from '../endpoints'

type EndpointParams = Parameters<typeof getAccessManagementAccount>[0]

export const getAccessManagementAccountQueryKey = () => [
  'accessManagementAccount',
]

export const useAccessManagementAccount = (
  params: EndpointParams,
  opts?: UseEndpointOptionsFromProvider<typeof getAccessManagementAccount>,
) =>
  useEndpoint(
    getAccessManagementAccountQueryKey(),
    getAccessManagementAccount(params),
    opts,
  )
